export default "__VITE_ASSET__BMbnaDDT__"